import { useUI }       from '../../context/UIContext';
import { useWishlist } from '../../context/WishlistContext';
import { useCart }     from '../../context/CartContext';
import { useCurrency } from '../../context/CurrencyContext';
import { buildEnquiryMessage } from '../../lib/whatsapp';
// const BASE = 'http://localhost/CODIZN-full-project%20(2)/codizn/backend';
// const imgSrc = (url) => !url ? null : url.startsWith('http') ? url : `${BASE}${url}`;
import { imgSrc } from '../../lib/env';
// const imgSrc = (url) => !url ? null : url.startsWith('http') ? url : `http://localhost${url}`;

export default function ProductCard({ product: p }) {
  const { openQV }               = useUI();
  const { toggle, isWishlisted } = useWishlist();
  const { addItem }              = useCart();
  const { fmt }                  = useCurrency();

  const isSoldOut  = p.stock === 0;
  const wishlisted = isWishlisted(p.id);
  const src        = imgSrc(p.img);

  return (
    <article style={{ display: 'flex', flexDirection: 'column', position: 'relative', zIndex: 0, }}
      onMouseEnter={(e) => {
        const btn = e.currentTarget.querySelector('.hover-actions');
        if (btn) btn.style.transform = 'translateY(0)';
      }}
      onMouseLeave={(e) => {
        const btn = e.currentTarget.querySelector('.hover-actions');
        if (btn) btn.style.transform = 'translateY(100%)';
      }}>

      {/* Image container */}
      <div className="img-zoom-wrap" style={{ position: 'relative', aspectRatio: '3/4', background: 'var(--cream-2)', marginBottom: 14, opacity: isSoldOut ? 0.65 : 1 }}>
        {src
          ? <img src={src} alt={`${p.brand} ${p.name}`} className="img-zoom"
              style={{ width: '100%', height: '100%', objectFit: 'cover', mixBlendMode: 'multiply', cursor: isSoldOut ? 'default' : 'pointer' }}
              onClick={() => !isSoldOut && openQV(p)} />
          : <div onClick={() => !isSoldOut && openQV(p)}
              style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
              <span style={{ fontSize: 11, color: '#d1d5db', letterSpacing: '0.15em', textTransform: 'uppercase' }}>No Image</span>
            </div>
        }

        {/* Badge + wishlist row */}
        <div style={{ position: 'absolute', top: 10, left: 10, right: 10, display: 'flex', justifyContent: 'space-between', zIndex: 2, pointerEvents: 'none' }}>
          <div style={{ pointerEvents: 'all' }}>
            {(isSoldOut || p.badge) && (
              <span style={{ fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase', fontWeight: 600, padding: '3px 8px', background: isSoldOut ? 'var(--dark)' : '#fff', color: isSoldOut ? '#fff' : '#6b7280', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
                {isSoldOut ? 'Sold Out' : p.badge}
              </span>
            )}
          </div>
          <button onClick={() => toggle(p.id)} aria-label={wishlisted ? 'Remove wishlist' : 'Add wishlist'}
            style={{ pointerEvents: 'all', width: 30, height: 30, borderRadius: '50%', background: 'rgba(255,255,255,0.9)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.1)', color: wishlisted ? '#ef4444' : '#9ca3af', transition: 'color 0.2s' }}>
            <svg width={14} height={14} fill={wishlisted ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
          </button>
        </div>

        {/* Condition tag */}
        {p.condition && p.condition !== 'New' && (
          <div style={{ position: 'absolute', bottom: 10, left: 10, fontSize: 10, fontWeight: 500, color: '#6b7280', background: 'rgba(255,255,255,0.9)', padding: '2px 7px', letterSpacing: '0.08em' }}>
            {p.condition}
          </div>
        )}

        {/* Hover actions */}
        <div className="hover-actions" style={{ position: 'absolute', bottom: 0, left: 0, right: 0, display: 'flex', gap: 6, padding: 10, transform: 'translateY(100%)', transition: 'transform 0.45s cubic-bezier(0.16,1,0.3,1)', zIndex: 2 }}>
          {isSoldOut
            ? <button disabled style={{ flex: 1, padding: '10px 0', background: '#e5e7eb', color: '#9ca3af', fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', fontWeight: 600, border: 'none' }}>Sold Out</button>
            : <button onClick={() => addItem(p)}
                style={{ flex: 1, padding: '10px 0', background: '#fff', border: '1px solid var(--dark)', color: 'var(--dark)', fontSize: 10, letterSpacing: '0.2em', textTransform: 'uppercase', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s' }}
                onMouseEnter={(e) => { e.target.style.background = 'var(--dark)'; e.target.style.color = '#fff'; }}
                onMouseLeave={(e) => { e.target.style.background = '#fff'; e.target.style.color = 'var(--dark)'; }}>
                Add to Bag
              </button>
          }
          <button onClick={() => openQV(p)} title="Quick View"
            style={{ width: 40, background: '#fff', border: '1px solid var(--dark)', color: 'var(--dark)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', transition: 'all 0.2s' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--dark)'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = 'var(--dark)'; }}>
            <svg width={14} height={14} fill="none" stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          </button>
        </div>
      </div>

      {/* Info */}
      {/* <div style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => openQV(p)}>
        <div style={{ fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--grey-mid)', fontWeight: 500, marginBottom: 5 }}>{p.brand}</div>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: 17, color: 'var(--dark)', lineHeight: 1.3, marginBottom: 8, padding: '0 4px' }}>{p.name}</div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
          <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--dark)' }}>{fmt(p.price)}</span>
          {p.was && <span style={{ fontSize: 12, color: '#d1d5db', textDecoration: 'line-through' }}>{fmt(Number(p.was))}</span>}
        </div>
      </div> */}
      {/* Info */}
      <div style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => openQV(p)}>
        <div style={{ fontSize: 10, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--grey-mid)', fontWeight: 500, marginBottom: 5 }}>{p.brand}</div>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: 17, color: 'var(--dark)', lineHeight: 1.3, marginBottom: 8, padding: '0 4px' }}>{p.name}</div>
        
        {/* ↓ REPLACE from here */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
      {(!p.price || Number(p.price) === 0)
            // ? <a href="https://wa.me/YOUR_WHATSAPP_NUMBER" target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', padding: '6px 14px', background: 'var(--dark)', color: '#fff', textDecoration: 'none', display: 'inline-block' }}>Contact Us</a>
            ? <button
              onClick={e => {
                e.stopPropagation();
                window.open(buildEnquiryMessage(p), '_blank');
              }}
              style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', padding: '6px 14px', background: 'var(--dark)', color: '#fff', border: 'none', cursor: 'pointer', display: 'inline-block' }}>
              Contact Us
            </button>
            : <>
                <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--dark)' }}>{fmt(p.price)}</span>
                {p.was && <span style={{ fontSize: 12, color: '#d1d5db', textDecoration: 'line-through' }}>{fmt(Number(p.was))}</span>}
              </>
          }
        </div>
        {/* ↑ REPLACE to here */}

      </div>
    </article>
  );
}
